<script setup>
import AppLayout from '@/layouts/AppLayout.vue'

const props = defineProps({
  fonction:      Object,
  can_update:    Boolean,
  can_see_costs: Boolean,
  index_url:     String,
})

function fmtCurrency(val) {
  if (val === null || val === undefined) return '—'
  return new Intl.NumberFormat('fr-CA', { style: 'currency', currency: 'CAD', minimumFractionDigits: 2 }).format(val)
}
</script>

<template>
  <AppLayout>
    <template #topbar-left>
      <div class="flex items-center gap-3">
        <a :href="index_url" class="text-outline hover:text-on-surface transition-colors">
          <span class="material-symbols-outlined text-xl">arrow_back</span>
        </a>
        <span class="text-outline">/</span>
        <span class="text-sm font-black uppercase tracking-widest text-on-surface">{{ fonction.description }}</span>
      </div>
    </template>

    <template #topbar-right>
      <a v-if="can_update" :href="fonction.edit_url"
         class="machined-sheen px-5 py-2.5 rounded-md text-on-primary font-black text-xs uppercase tracking-widest flex items-center gap-2 hover:brightness-110 transition-all shadow-lg">
        <span class="material-symbols-outlined text-sm">edit_note</span>Modifier
      </a>
    </template>

    <div class="p-8 space-y-6">

      <!-- En-tête -->
      <div>
        <h1 class="text-2xl font-black text-on-surface tracking-tight uppercase">{{ fonction.description }}</h1>
        <p class="text-sm text-outline mt-1">
          Profession <span class="font-mono font-bold text-primary">{{ fonction.code }}</span>
        </p>
      </div>

      <!-- Détails -->
      <div class="bg-surface-container rounded-xl overflow-hidden shadow-xl border border-outline-variant/10">
        <div class="px-6 py-4 bg-surface-container-high/60 border-b border-outline-variant/15">
          <h2 class="text-[11px] font-black uppercase tracking-widest text-on-surface">Détails</h2>
        </div>
        <table class="w-full text-left border-collapse">
          <tbody class="divide-y divide-outline-variant/10">
            <tr class="hover:bg-surface-container-highest/20 transition-colors">
              <th class="px-6 py-4 text-[10px] font-black uppercase tracking-widest text-outline w-48">Code</th>
              <td class="px-6 py-4 font-mono text-sm font-bold text-primary">{{ fonction.code }}</td>
            </tr>
            <tr class="hover:bg-surface-container-highest/20 transition-colors">
              <th class="px-6 py-4 text-[10px] font-black uppercase tracking-widest text-outline w-48">Description</th>
              <td class="px-6 py-4 text-sm text-on-surface">{{ fonction.description }}</td>
            </tr>
            <tr v-if="can_see_costs" class="hover:bg-surface-container-highest/20 transition-colors">
              <th class="px-6 py-4 text-[10px] font-black uppercase tracking-widest text-outline w-48">Taux horaire</th>
              <td class="px-6 py-4 font-mono text-sm font-bold text-on-surface">{{ fmtCurrency(fonction.taux_horaire) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </AppLayout>
</template>
